import {useRef, useState} from "react";
import emailjs from "emailjs-com";

export default function PricePage() {

    const [sendingComplaint, setSendingComplaint] = useState(false);
    const complaintFormRef = useRef(null);
    const SERVICE_ID = "service_sw76wj2";
    const COMPLAINT_TEMPLATE_ID = "template_auemxvb"; // "Բողոք" template
    const PUBLIC_KEY = "DgPK5jQk58ECGFxnQ";

    const sendComplaint = async (e) => {
        e.preventDefault();
        if (!complaintFormRef.current) return;

        try {
            setSendingComplaint(true);
            await emailjs.sendForm(
                SERVICE_ID,
                COMPLAINT_TEMPLATE_ID,
                complaintFormRef.current,
                PUBLIC_KEY
            );
            alert("Բողոքը ուղարկված է ✅");
            complaintFormRef.current.reset();
        } catch (err) {
            alert("Սխալ տեղի ունեցավ փորձեք կրկին ❌");
        } finally {
            setSendingComplaint(false);
        }
    };


    return (
    <div className="prose max-w-none">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Բողոքներ և գանգատներ</h2>
      <p>
          «ԹԵՍԹ ԻՆՎԵՍՏ» ՍՊԸ սերտիֆիկացման մարմինը մշակել  և  ներդրել է MP-07-2025 «ԲՈՂՈՔՆԵՐ ԵՎ ԳԱՆԳԱՏՆԵՐ» ընթացակարգը, որի նպատակն է՝

          <br/>  <br/>  •	Ապահովել բողոքների և գանգատների ստացման, գրանցման, գնահատման և որոշումների կայացման ժամանակ ԳՕՍՏ ԻՍՕ/ԻԷԿ 17065-2013 ստանդարտի պահանջների կատարումը:
          <br/>  <br/>  •	Սահմանել բողոքների և գանգատների քննարկման և գնահատման արդյունքում նախաձեռնված միջոցառումների և դրանց իրականացման գործողությունները:
          <br/> <br/>
          Կարևոր է. Մեր գործունեության առանցքում հաճախորդների վստահությունն է և արտադրանքի անվտանգության բարձր չափանիշների ապահովումը:
      </p>

        <h3 className="text-2xl font-bold mb-6 text-center mt-8">
            Բողոքներ և գանգատներ
        </h3>

        <form ref={complaintFormRef} onSubmit={sendComplaint} className="space-y-4">
            <input
                name="full_name"
                className="w-full border rounded-lg p-3"
                placeholder="Անուն Ազգանուն"
                required
            />

            <input
                name="complaint_phone"
                className="w-full border rounded-lg p-3"
                placeholder="Հեռախոս"
                required
            />

            <input
                name="complaint_email"
                type="email"
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                placeholder="Էլ Հասցե"
                required
            />

            <textarea
                name="complaint_message"
                rows={4}
                className="w-full border rounded-lg p-3"
                placeholder="Նկարագրեք խնդիրը"
                required
            />

            <button
                type="submit"
                disabled={sendingComplaint}
                className="w-full bg-blue-900 text-white py-3 rounded-lg hover:bg-blue-800 disabled:opacity-60"
            >
                {sendingComplaint ? "Ուղարկվում է..." : "Ուղարկել բողոքը"}
            </button>
        </form>


    </div>
  );
}
